import { render, staticRenderFns } from "./batches.vue?vue&type=template&id=6171d65a&"
import script from "./batches.vue?vue&type=script&lang=js&"
export * from "./batches.vue?vue&type=script&lang=js&"
import style0 from "./batches.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports